/* ========================================================================
//	HOME
======================================================================== */

(function ($) {
	
	$('.slider').slick({
		dots: true,
		arrows: false,
		infinite: true,
		speed: 500,
		fade: true,
		cssEase: 'cubic-bezier(0.7, 0, 0.3, 1)',
		autoplay: true,
		autoplaySpeed: 10000
	});
	
	
	MyTools.initPg('HOME');
	
})(jQuery, MyTools);